import script from "./EventSetupPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSetupPage.vue?vue&type=script&setup=true&lang=js"

import "./EventSetupPage.vue?vue&type=style&index=0&id=f8ac832c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8ac832c"]])

export default __exports__